import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaSearch, FaCoffee, FaGlassWhiskey, FaHamburger, FaPizzaSlice, FaIceCream, FaCocktail, FaEye, FaTimes, FaGift, FaPercent, FaBirthdayCake, FaQrcode } from 'react-icons/fa';

const CATEGORY_ICONS = {
    default: FaHamburger,
    bebidas: FaGlassWhiskey,
    cafes: FaCoffee,
    postres: FaIceCream,
    pizzas: FaPizzaSlice,
    cocktails: FaCocktail,
};

const WelcomeModal = ({ isOpen, onClose, marca, texts, styles }) => {
    if (!isOpen) return null;

    const modalBgColor = styles?.modalBackgroundColor || '#FFFFFF';
    const modalOverlayColor = styles?.modalOverlayColor || 'rgba(0, 0, 0, 0.5)';
    const benefitCardBg = styles?.benefitCardBackgroundColor || '#EFF6FF';
    const benefitIconColor = styles?.benefitIconColor || '#2563EB';
    const buttonBgColor = styles?.floatingButtonBackgroundColor || '#2563EB';
    const buttonTextColor = styles?.floatingButtonTextColor || '#FFFFFF';
    const titleColor = styles?.titleColor || '#111827';
    const descriptionColor = styles?.descriptionColor || '#6B7280';

    return (
        <div className="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
            <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <div
                    className="fixed inset-0 transition-opacity"
                    style={{ backgroundColor: modalOverlayColor }}
                    aria-hidden="true"
                    onClick={onClose}
                ></div>

                <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                <div
                    className="inline-block align-bottom rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
                    style={{ backgroundColor: modalBgColor }}
                >
                    <div className="absolute top-0 right-0 pt-4 pr-4">
                        <button
                            onClick={onClose}
                            className="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none"
                            style={{ backgroundColor: modalBgColor }}
                        >
                            <FaTimes className="h-6 w-6" />
                        </button>
                    </div>

                    <div className="px-4 pt-5 pb-4 sm:p-6 sm:pb-4" style={{ backgroundColor: modalBgColor }}>
                        <div className="sm:flex sm:items-start">
                            <div className="mt-3 text-center sm:mt-0 sm:text-left w-full">
                                <div className="text-center mb-6">
                                    <FaGift className="mx-auto h-12 w-12 mb-4" style={{ color: benefitIconColor }} />
                                    <h3
                                        className="text-2xl leading-6 font-bold mb-2"
                                        id="modal-title"
                                        style={{ color: titleColor }}
                                    >
                                        {texts?.welcomeModalTitle || `¡Únete al Club de ${marca?.nombre}!`}
                                    </h3>
                                    <p className="text-sm" style={{ color: descriptionColor }}>
                                        {texts?.welcomeModalDescription || 'Disfruta de beneficios exclusivos y ofertas especiales'}
                                    </p>
                                </div>

                                <div className="mt-6 grid grid-cols-1 gap-4">
                                    <div className="flex items-center p-4 rounded-lg" style={{ backgroundColor: benefitCardBg }}>
                                        <FaPercent className="h-6 w-6 mr-3" style={{ color: benefitIconColor }} />
                                        <div>
                                            <h4 className="text-sm font-medium" style={{ color: titleColor }}>
                                                {texts?.benefit1Title || 'Descuentos Exclusivos'}
                                            </h4>
                                            <p className="text-xs" style={{ color: descriptionColor }}>
                                                {texts?.benefit1Description || 'Accede a ofertas especiales solo para miembros'}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="flex items-center p-4 rounded-lg" style={{ backgroundColor: benefitCardBg }}>
                                        <FaBirthdayCake className="h-6 w-6 mr-3" style={{ color: benefitIconColor }} />
                                        <div>
                                            <h4 className="text-sm font-medium" style={{ color: titleColor }}>
                                                {texts?.benefit2Title || 'Regalo de Cumpleaños'}
                                            </h4>
                                            <p className="text-xs" style={{ color: descriptionColor }}>
                                                {texts?.benefit2Description || 'Sorpresas especiales en tu día'}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="flex items-center p-4 rounded-lg" style={{ backgroundColor: benefitCardBg }}>
                                        <FaQrcode className="h-6 w-6 mr-3" style={{ color: benefitIconColor }} />
                                        <div>
                                            <h4 className="text-sm font-medium" style={{ color: titleColor }}>
                                                {texts?.benefit3Title || 'Tarjeta Digital'}
                                            </h4>
                                            <p className="text-xs" style={{ color: descriptionColor }}>
                                                {texts?.benefit3Description || 'Acumula puntos en cada visita'}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-8">
                                    <Link
                                        to={`/qr-register/${marca?.tiendas?.[0]}`}
                                        className="w-full flex justify-center items-center px-4 py-3 border border-transparent text-base font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 sm:text-sm"
                                        style={{
                                            backgroundColor: buttonBgColor,
                                            color: buttonTextColor,
                                            focusRingColor: buttonBgColor
                                        }}
                                    >
                                        {texts?.joinButtonText || 'Unirme Ahora'}
                                    </Link>
                                    <button
                                        onClick={onClose}
                                        className="mt-3 w-full flex justify-center items-center px-4 py-3 border text-base font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 sm:text-sm"
                                        style={{
                                            backgroundColor: modalBgColor,
                                            color: descriptionColor,
                                            borderColor: '#D1D5DB'
                                        }}
                                    >
                                        {texts?.maybeLaterButtonText || 'Quizás más tarde'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const ImagePreviewModal = ({ imageUrl, productName, onClose }) => {
    if (!imageUrl) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-75"
            onClick={onClose}>
            <div className="relative max-w-2xl w-full">
                <button
                    onClick={onClose}
                    className="absolute -top-10 right-0 text-white hover:text-gray-300 transition-colors"
                >
                    <FaTimes className="w-6 h-6" />
                </button>
                <div className="bg-white rounded-lg overflow-hidden">
                    <img
                        src={imageUrl}
                        alt={productName}
                        className="w-full h-auto"
                        onClick={e => e.stopPropagation()}
                    />
                    <div className="p-4 bg-white">
                        <h3 className="text-lg font-semibold text-gray-900">{productName}</h3>
                    </div>
                </div>
            </div>
        </div>
    );
};

/**
 * Componente de contenido de ProductosPublicPage que puede ser usado tanto en la página real como en el preview
 * @param {Object} props
 * @param {Object} props.marca - Datos de la marca
 * @param {Array} props.productos - Lista de productos
 * @param {Array} props.categorias - Lista de categorías
 * @param {Object} props.texts - Textos personalizados
 * @param {Object} props.styles - Estilos personalizados
 * @param {string} props.layout - Layout seleccionado ('grid', 'list', 'cards')
 * @param {Object} props.layoutOptions - Opciones de layout
 * @param {Object} props.config - Configuración (showWelcomeModal, welcomeModalDelay, etc.)
 * @param {Function} [props.onImageClick] - Callback cuando se hace clic en una imagen (opcional, para preview)
 * @param {boolean} props.isPreview - Si es true, desactiva funcionalidad interactiva
 */
const ProductosPublicPageContent = ({
    marca,
    productos = [],
    categorias = [],
    texts = {},
    styles = {},
    layout = 'grid',
    layoutOptions = {},
    config = {},
    onImageClick,
    isPreview = false
}) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedCategoria, setSelectedCategoria] = useState('');
    const [showWelcomeModal, setShowWelcomeModal] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedProductName, setSelectedProductName] = useState('');

    // Mostrar modal de bienvenida si está configurado
    useEffect(() => {
        if (config.showWelcomeModal && !isPreview) {
            const modalDelay = (config.welcomeModalDelay || 30) * 1000;
            const timeoutId = setTimeout(() => {
                setShowWelcomeModal(true);
            }, modalDelay);
            return () => clearTimeout(timeoutId);
        }
    }, [config.showWelcomeModal, config.welcomeModalDelay, isPreview]);

    // Calcular estilos aplicando personalización
    const headerBgColor = styles.headerBackgroundColor || '#4F46E5';
    const headerTextColor = styles.headerTextColor || '#FFFFFF';
    const categoryTabActiveColor = styles.categoryTabActiveColor || '#2563EB';
    const categoryTabInactiveColor = styles.categoryTabInactiveColor || '#F3F4F6';
    const productCardBgColor = styles.productCardBackgroundColor || '#FFFFFF';
    const productCardHoverColor = styles.productCardHoverColor || '#F9FAFB';
    const productNameColor = styles.productNameColor || '#111827';
    const productDescriptionColor = styles.productDescriptionColor || '#6B7280';
    const productPriceColor = styles.productPriceColor || '#2563EB';
    const floatingButtonBgColor = styles.floatingButtonBackgroundColor || '#2563EB';
    const floatingButtonTextColor = styles.floatingButtonTextColor || '#FFFFFF';
    const inputBorderColor = styles.inputBorderColor || '#D1D5DB';
    const inputFocusColor = styles.inputFocusColor || '#3B82F6';
    const fontFamily = styles.fontFamily || 'sans-serif';
    const fontSize = styles.fontSize || '16px';

    // Determinar clases CSS según layout y opciones
    const headerClasses = {
        sticky: 'sticky top-0 z-50 w-full shadow-md',
        static: 'w-full shadow-md',
        transparent: 'sticky top-0 z-50 w-full bg-transparent'
    }[layoutOptions.headerStyle] || 'sticky top-0 z-50 w-full shadow-md';

    const logoPositionClasses = {
        left: 'justify-start',
        center: 'justify-center'
    }[layoutOptions.logoPosition] || 'justify-start';

    // Determinar estilo de tarjeta según layoutOptions
    const productCardStyle = layoutOptions.productCardStyle || 'default';
    const cardStyleClasses = {
        default: 'rounded-xl shadow-sm',
        compact: 'rounded-lg shadow-sm',
        detailed: 'rounded-2xl shadow-md'
    }[productCardStyle] || 'rounded-xl shadow-sm';

    // Función para obtener una imagen representativa de la categoría
    const getCategoryImage = (categoria, productos) => {
        const productoConImagen = productos.find(p => p.imageUrl);
        if (productoConImagen) {
            return productoConImagen.imageUrl;
        }
        return null;
    };

    // Función para obtener el icono de la categoría
    const getCategoryIcon = (categoryName) => {
        const normalizedName = categoryName.toLowerCase();
        for (const [key, icon] of Object.entries(CATEGORY_ICONS)) {
            if (normalizedName.includes(key)) {
                return icon;
            }
        }
        return CATEGORY_ICONS.default;
    };

    const handleImageClick = (imageUrl, productName, e) => {
        e.stopPropagation();
        if (isPreview) {
            return;
        }
        if (onImageClick) {
            onImageClick(imageUrl, productName);
        } else {
            setSelectedImage(imageUrl);
            setSelectedProductName(productName);
        }
    };

    const productosPorCategoria = categorias.reduce((acc, categoria) => {
        const productosCategoria = productos.filter(
            producto => producto.categoria._id === categoria._id &&
                (!searchTerm ||
                    producto.nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    producto.descripcion?.toLowerCase().includes(searchTerm.toLowerCase())
                )
        );
        if (productosCategoria.length > 0) {
            acc[categoria._id] = productosCategoria;
        }
        return acc;
    }, {});

    if (!marca) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="text-center text-gray-600">
                    <p className="text-xl">Marca no disponible en preview</p>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gray-50" style={{ fontFamily, fontSize }}>
            {/* Header */}
            {layoutOptions.headerStyle !== 'transparent' && (
                <div
                    className={headerClasses}
                    style={{ backgroundColor: headerBgColor }}
                >
                    <div className="max-w-7xl mx-auto px-4 py-2">
                        <div className="flex items-center justify-between">
                            <div className={`flex items-center ${logoPositionClasses === 'justify-center' ? 'flex-1 justify-center' : ''}`}>
                                {layoutOptions.showLogo && marca.logotipo && (
                                    <img
                                        src={marca.logotipo.cdnUrl || marca.logotipo.url}
                                        alt={`Logo de ${marca.nombre}`}
                                        className="h-10 w-10 object-contain bg-white rounded-lg shadow-sm p-1"
                                    />
                                )}
                                <div className={layoutOptions.logoPosition === 'center' ? 'text-center ml-3' : 'ml-3'}>
                                    <h1 className="text-lg font-bold" style={{ color: headerTextColor }}>
                                        {marca.nombre}
                                    </h1>
                                    {layoutOptions.showSlogan && marca.eslogan && (
                                        <p className="text-xs opacity-90" style={{ color: headerTextColor }}>
                                            {marca.eslogan}
                                        </p>
                                    )}
                                </div>
                            </div>
                            {config.showSearchButton && (
                                <button
                                    onClick={() => setShowSearch(!showSearch)}
                                    className="p-2 rounded-full transition-colors"
                                    style={{ color: headerTextColor }}
                                    onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.1)'}
                                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                    disabled={isPreview}
                                >
                                    <FaSearch className="w-5 h-5" />
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* Search Bar Expandible */}
            {showSearch && config.showSearchButton && (
                <div className="w-full bg-white shadow-md p-2 transition-all">
                    <div className="relative max-w-7xl mx-auto">
                        <input
                            type="text"
                            placeholder={texts.searchPlaceholder || 'Buscar...'}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="w-full pl-10 pr-4 py-2 border rounded-lg focus:ring-2 focus:border-transparent"
                            style={{
                                borderColor: inputBorderColor,
                                focusRingColor: inputFocusColor
                            }}
                            autoFocus
                            disabled={isPreview}
                        />
                        <FaSearch className="absolute left-3 top-3 text-gray-400" />
                    </div>
                </div>
            )}

            {/* Categorías como Tabs */}
            <div className="bg-white shadow-sm sticky top-14 z-40">
                <div className="max-w-7xl mx-auto px-4">
                    <div className="flex space-x-2 py-2 overflow-x-auto scrollbar-hide">
                        <button
                            onClick={() => setSelectedCategoria('')}
                            className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${!selectedCategoria
                                ? 'text-white'
                                : 'text-gray-700 hover:bg-gray-200'
                                }`}
                            style={!selectedCategoria ? {
                                backgroundColor: categoryTabActiveColor
                            } : {
                                backgroundColor: categoryTabInactiveColor
                            }}
                            disabled={isPreview}
                        >
                            Todo
                        </button>
                        {categorias.map((categoria) => (
                            <button
                                key={categoria._id}
                                onClick={() => setSelectedCategoria(categoria._id)}
                                className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${selectedCategoria === categoria._id
                                    ? 'text-white'
                                    : 'text-gray-700 hover:bg-gray-200'
                                    }`}
                                style={selectedCategoria === categoria._id ? {
                                    backgroundColor: categoryTabActiveColor
                                } : {
                                    backgroundColor: categoryTabInactiveColor
                                }}
                                disabled={isPreview}
                            >
                                {categoria.nombre}
                            </button>
                        ))}
                    </div>
                </div>
            </div>

            {/* Contenido Principal */}
            <div className="max-w-7xl mx-auto px-4 py-4 pb-20">
                {selectedCategoria ? (
                    // Vista de categoría seleccionada
                    <div className="space-y-4">
                        {/* Header de la categoría */}
                        {categorias.map(cat => cat._id === selectedCategoria && (
                            <div key={cat._id} className="mb-6">
                                <div className="relative h-40 rounded-xl overflow-hidden mb-4">
                                    {getCategoryImage(cat, productosPorCategoria[cat._id] || []) ? (
                                        <img
                                            src={getCategoryImage(cat, productosPorCategoria[cat._id] || [])}
                                            alt={cat.nombre}
                                            className="w-full h-full object-cover"
                                        />
                                    ) : (
                                        <div className="w-full h-full bg-gradient-to-r from-blue-500 to-blue-600 flex items-center justify-center">
                                            {React.createElement(getCategoryIcon(cat.nombre), {
                                                className: "text-white text-6xl"
                                            })}
                                        </div>
                                    )}
                                    <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
                                        <h2 className="text-2xl font-bold text-white">{cat.nombre}</h2>
                                    </div>
                                </div>
                                {/* Lista de productos - Renderizar según layout */}
                                {layout === 'grid' ? (
                                    // Layout Grid: Cuadrícula de productos
                                    <div
                                        className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 ${cardStyleClasses}`}
                                        style={{
                                            backgroundColor: 'transparent'
                                        }}
                                    >
                                        {productosPorCategoria[selectedCategoria]?.map((producto) => (
                                            <div
                                                key={producto._id}
                                                className="p-4 transition-colors"
                                                style={{
                                                    backgroundColor: productCardBgColor,
                                                    borderRadius: '0.75rem',
                                                    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)'
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = productCardHoverColor}
                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = productCardBgColor}
                                            >
                                                {producto.imageUrl && (
                                                    <div className="mb-3">
                                                        <img
                                                            src={producto.imageUrl}
                                                            alt={producto.nombre}
                                                            className="w-full h-32 object-cover rounded-lg"
                                                            onClick={(e) => handleImageClick(producto.imageUrl, producto.nombre, e)}
                                                            style={{ cursor: isPreview ? 'default' : 'pointer' }}
                                                        />
                                                    </div>
                                                )}
                                                <h3
                                                    className="text-base font-semibold leading-6 mb-1"
                                                    style={{ color: productNameColor }}
                                                >
                                                    {producto.nombre}
                                                </h3>
                                                {producto.descripcion && (
                                                    <p
                                                        className="text-sm line-clamp-2 mb-2"
                                                        style={{ color: productDescriptionColor }}
                                                    >
                                                        {producto.descripcion}
                                                    </p>
                                                )}
                                                <div className="flex items-center justify-between mt-3">
                                                    <span
                                                        className="text-lg font-bold"
                                                        style={{ color: productPriceColor }}
                                                    >
                                                        {producto.precio.toLocaleString('es-ES', {
                                                            style: 'currency',
                                                            currency: 'EUR'
                                                        })}
                                                    </span>
                                                    {producto.imageUrl && !isPreview && (
                                                        <button
                                                            onClick={(e) => handleImageClick(producto.imageUrl, producto.nombre, e)}
                                                            className="transition-colors p-1"
                                                            style={{ color: productPriceColor }}
                                                            onMouseEnter={(e) => e.target.style.opacity = '0.7'}
                                                            onMouseLeave={(e) => e.target.style.opacity = '1'}
                                                            title="Ver imagen"
                                                        >
                                                            <FaEye className="w-4 h-4" />
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : layout === 'cards' ? (
                                    // Layout Cards: Tarjetas grandes con más información
                                    <div
                                        className={`grid grid-cols-1 md:grid-cols-2 gap-6 ${cardStyleClasses}`}
                                        style={{
                                            backgroundColor: 'transparent'
                                        }}
                                    >
                                        {productosPorCategoria[selectedCategoria]?.map((producto) => (
                                            <div
                                                key={producto._id}
                                                className="p-6 transition-colors"
                                                style={{
                                                    backgroundColor: productCardBgColor,
                                                    borderRadius: '1rem',
                                                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = productCardHoverColor}
                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = productCardBgColor}
                                            >
                                                {producto.imageUrl && (
                                                    <div className="mb-4">
                                                        <img
                                                            src={producto.imageUrl}
                                                            alt={producto.nombre}
                                                            className="w-full h-48 object-cover rounded-lg"
                                                            onClick={(e) => handleImageClick(producto.imageUrl, producto.nombre, e)}
                                                            style={{ cursor: isPreview ? 'default' : 'pointer' }}
                                                        />
                                                    </div>
                                                )}
                                                <h3
                                                    className="text-xl font-bold leading-6 mb-2"
                                                    style={{ color: productNameColor }}
                                                >
                                                    {producto.nombre}
                                                </h3>
                                                {producto.descripcion && (
                                                    <p
                                                        className="text-sm mb-4 line-clamp-3"
                                                        style={{ color: productDescriptionColor }}
                                                    >
                                                        {producto.descripcion}
                                                    </p>
                                                )}
                                                <div className="flex items-center justify-between">
                                                    <span
                                                        className="text-2xl font-bold"
                                                        style={{ color: productPriceColor }}
                                                    >
                                                        {producto.precio.toLocaleString('es-ES', {
                                                            style: 'currency',
                                                            currency: 'EUR'
                                                        })}
                                                    </span>
                                                    {producto.imageUrl && !isPreview && (
                                                        <button
                                                            onClick={(e) => handleImageClick(producto.imageUrl, producto.nombre, e)}
                                                            className="transition-colors p-2"
                                                            style={{ color: productPriceColor }}
                                                            onMouseEnter={(e) => e.target.style.opacity = '0.7'}
                                                            onMouseLeave={(e) => e.target.style.opacity = '1'}
                                                            title="Ver imagen"
                                                        >
                                                            <FaEye className="w-5 h-5" />
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    // Layout List: Lista vertical (default)
                                    <div
                                        className={`${cardStyleClasses} divide-y`}
                                        style={{
                                            backgroundColor: productCardBgColor,
                                            borderColor: '#E5E7EB'
                                        }}
                                    >
                                        {productosPorCategoria[selectedCategoria]?.map((producto) => (
                                            <div
                                                key={producto._id}
                                                className="p-4 transition-colors"
                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = productCardHoverColor}
                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = productCardBgColor}
                                            >
                                                <div className="flex justify-between items-start gap-x-4">
                                                    <div className="min-w-0 flex-1">
                                                        <div className="flex items-center gap-2">
                                                            <h3
                                                                className="text-base font-semibold leading-6"
                                                                style={{ color: productNameColor }}
                                                            >
                                                                {producto.nombre}
                                                            </h3>
                                                            {producto.imageUrl && (
                                                                <button
                                                                    onClick={(e) => handleImageClick(producto.imageUrl, producto.nombre, e)}
                                                                    className="transition-colors"
                                                                    style={{ color: productPriceColor }}
                                                                    onMouseEnter={(e) => e.target.style.opacity = '0.7'}
                                                                    onMouseLeave={(e) => e.target.style.opacity = '1'}
                                                                    title="Ver imagen"
                                                                    disabled={isPreview}
                                                                >
                                                                    <FaEye className="w-4 h-4" />
                                                                </button>
                                                            )}
                                                        </div>
                                                        {producto.descripcion && (
                                                            <p
                                                                className="mt-1 text-sm line-clamp-2"
                                                                style={{ color: productDescriptionColor }}
                                                            >
                                                                {producto.descripcion}
                                                            </p>
                                                        )}
                                                    </div>
                                                    <div className="flex-none">
                                                        <span
                                                            className="text-base font-bold"
                                                            style={{ color: productPriceColor }}
                                                        >
                                                            {producto.precio.toLocaleString('es-ES', {
                                                                style: 'currency',
                                                                currency: 'EUR'
                                                            })}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                ) : (
                    // Vista general de categorías
                    <div className="space-y-8">
                        {categorias.map((categoria) => {
                            const productosCategoria = productosPorCategoria[categoria._id] || [];
                            if (productosCategoria.length === 0) return null;

                            return (
                                <div key={categoria._id} className="space-y-4">
                                    {/* Header de categoría con imagen o icono */}
                                    <div
                                        className="relative h-32 rounded-xl overflow-hidden cursor-pointer"
                                        onClick={() => !isPreview && setSelectedCategoria(categoria._id)}
                                    >
                                        {getCategoryImage(categoria, productosCategoria) ? (
                                            <img
                                                src={getCategoryImage(categoria, productosCategoria)}
                                                alt={categoria.nombre}
                                                className="w-full h-full object-cover"
                                            />
                                        ) : (
                                            <div className="w-full h-full bg-gradient-to-r from-blue-500 to-blue-600 flex items-center justify-center">
                                                {React.createElement(getCategoryIcon(categoria.nombre), {
                                                    className: "text-white text-5xl"
                                                })}
                                            </div>
                                        )}
                                        <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-between px-6">
                                            <h2 className="text-xl font-bold text-white">{categoria.nombre}</h2>
                                            <span className="text-sm text-white bg-white bg-opacity-20 px-3 py-1 rounded-full">
                                                {productosCategoria.length} productos
                                            </span>
                                        </div>
                                    </div>

                                    {/* Preview de productos - Renderizar según layout */}
                                    {layout === 'grid' ? (
                                        // Layout Grid: Cuadrícula de productos
                                        <div
                                            className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 ${cardStyleClasses}`}
                                            style={{
                                                backgroundColor: 'transparent'
                                            }}
                                        >
                                            {productosCategoria.slice(0, config.productsPerCategoryPreview || 3).map((producto) => (
                                                <div
                                                    key={producto._id}
                                                    className="p-4 transition-colors"
                                                    style={{
                                                        backgroundColor: productCardBgColor,
                                                        borderRadius: '0.75rem',
                                                        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)'
                                                    }}
                                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = productCardHoverColor}
                                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = productCardBgColor}
                                                >
                                                    {producto.imageUrl && (
                                                        <div className="mb-3">
                                                            <img
                                                                src={producto.imageUrl}
                                                                alt={producto.nombre}
                                                                className="w-full h-32 object-cover rounded-lg"
                                                                onClick={(e) => handleImageClick(producto.imageUrl, producto.nombre, e)}
                                                                style={{ cursor: isPreview ? 'default' : 'pointer' }}
                                                            />
                                                        </div>
                                                    )}
                                                    <h3
                                                        className="text-base font-semibold leading-6 mb-1"
                                                        style={{ color: productNameColor }}
                                                    >
                                                        {producto.nombre}
                                                    </h3>
                                                    {producto.descripcion && (
                                                        <p
                                                            className="text-sm line-clamp-2 mb-2"
                                                            style={{ color: productDescriptionColor }}
                                                        >
                                                            {producto.descripcion}
                                                        </p>
                                                    )}
                                                    <div className="flex items-center justify-between mt-3">
                                                        <span
                                                            className="text-lg font-bold"
                                                            style={{ color: productPriceColor }}
                                                        >
                                                            {producto.precio.toLocaleString('es-ES', {
                                                                style: 'currency',
                                                                currency: 'EUR'
                                                            })}
                                                        </span>
                                                        {producto.imageUrl && !isPreview && (
                                                            <button
                                                                onClick={(e) => handleImageClick(producto.imageUrl, producto.nombre, e)}
                                                                className="transition-colors p-1"
                                                                style={{ color: productPriceColor }}
                                                                onMouseEnter={(e) => e.target.style.opacity = '0.7'}
                                                                onMouseLeave={(e) => e.target.style.opacity = '1'}
                                                                title="Ver imagen"
                                                            >
                                                                <FaEye className="w-4 h-4" />
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                            {productosCategoria.length > (config.productsPerCategoryPreview || 3) && (
                                                <div
                                                    className="col-span-full p-4 text-center cursor-pointer transition-colors rounded-lg"
                                                    style={{
                                                        backgroundColor: productCardBgColor,
                                                        border: '2px dashed #D1D5DB'
                                                    }}
                                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = productCardHoverColor}
                                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = productCardBgColor}
                                                    onClick={() => !isPreview && setSelectedCategoria(categoria._id)}
                                                >
                                                    <span
                                                        className="font-medium"
                                                        style={{ color: productPriceColor }}
                                                    >
                                                        Ver {productosCategoria.length - (config.productsPerCategoryPreview || 3)} productos más
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    ) : layout === 'cards' ? (
                                        // Layout Cards: Tarjetas grandes con más información
                                        <div
                                            className={`grid grid-cols-1 md:grid-cols-2 gap-6 ${cardStyleClasses}`}
                                            style={{
                                                backgroundColor: 'transparent'
                                            }}
                                        >
                                            {productosCategoria.slice(0, config.productsPerCategoryPreview || 3).map((producto) => (
                                                <div
                                                    key={producto._id}
                                                    className="p-6 transition-colors"
                                                    style={{
                                                        backgroundColor: productCardBgColor,
                                                        borderRadius: '1rem',
                                                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                                                    }}
                                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = productCardHoverColor}
                                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = productCardBgColor}
                                                >
                                                    {producto.imageUrl && (
                                                        <div className="mb-4">
                                                            <img
                                                                src={producto.imageUrl}
                                                                alt={producto.nombre}
                                                                className="w-full h-48 object-cover rounded-lg"
                                                                onClick={(e) => handleImageClick(producto.imageUrl, producto.nombre, e)}
                                                                style={{ cursor: isPreview ? 'default' : 'pointer' }}
                                                            />
                                                        </div>
                                                    )}
                                                    <h3
                                                        className="text-xl font-bold leading-6 mb-2"
                                                        style={{ color: productNameColor }}
                                                    >
                                                        {producto.nombre}
                                                    </h3>
                                                    {producto.descripcion && (
                                                        <p
                                                            className="text-sm mb-4 line-clamp-3"
                                                            style={{ color: productDescriptionColor }}
                                                        >
                                                            {producto.descripcion}
                                                        </p>
                                                    )}
                                                    <div className="flex items-center justify-between">
                                                        <span
                                                            className="text-2xl font-bold"
                                                            style={{ color: productPriceColor }}
                                                        >
                                                            {producto.precio.toLocaleString('es-ES', {
                                                                style: 'currency',
                                                                currency: 'EUR'
                                                            })}
                                                        </span>
                                                        {producto.imageUrl && !isPreview && (
                                                            <button
                                                                onClick={(e) => handleImageClick(producto.imageUrl, producto.nombre, e)}
                                                                className="transition-colors p-2"
                                                                style={{ color: productPriceColor }}
                                                                onMouseEnter={(e) => e.target.style.opacity = '0.7'}
                                                                onMouseLeave={(e) => e.target.style.opacity = '1'}
                                                                title="Ver imagen"
                                                            >
                                                                <FaEye className="w-5 h-5" />
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                            {productosCategoria.length > (config.productsPerCategoryPreview || 3) && (
                                                <div
                                                    className="col-span-full p-6 text-center cursor-pointer transition-colors rounded-lg"
                                                    style={{
                                                        backgroundColor: productCardBgColor,
                                                        border: '2px dashed #D1D5DB'
                                                    }}
                                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = productCardHoverColor}
                                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = productCardBgColor}
                                                    onClick={() => !isPreview && setSelectedCategoria(categoria._id)}
                                                >
                                                    <span
                                                        className="font-medium text-lg"
                                                        style={{ color: productPriceColor }}
                                                    >
                                                        Ver {productosCategoria.length - (config.productsPerCategoryPreview || 3)} productos más
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        // Layout List: Lista vertical (default)
                                        <div
                                            className={`${cardStyleClasses} divide-y`}
                                            style={{
                                                backgroundColor: productCardBgColor,
                                                borderColor: '#E5E7EB'
                                            }}
                                        >
                                            {productosCategoria.slice(0, config.productsPerCategoryPreview || 3).map((producto) => (
                                                <div
                                                    key={producto._id}
                                                    className="p-4"
                                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = productCardHoverColor}
                                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = productCardBgColor}
                                                >
                                                    <div className="flex justify-between items-start gap-x-4">
                                                        <div className="min-w-0 flex-1">
                                                            <div className="flex items-center gap-2">
                                                                <h3
                                                                    className="text-base font-semibold leading-6"
                                                                    style={{ color: productNameColor }}
                                                                >
                                                                    {producto.nombre}
                                                                </h3>
                                                                {producto.imageUrl && (
                                                                    <button
                                                                        onClick={(e) => handleImageClick(producto.imageUrl, producto.nombre, e)}
                                                                        className="transition-colors"
                                                                        style={{ color: productPriceColor }}
                                                                        onMouseEnter={(e) => e.target.style.opacity = '0.7'}
                                                                        onMouseLeave={(e) => e.target.style.opacity = '1'}
                                                                        title="Ver imagen"
                                                                        disabled={isPreview}
                                                                    >
                                                                        <FaEye className="w-4 h-4" />
                                                                    </button>
                                                                )}
                                                            </div>
                                                            {producto.descripcion && (
                                                                <p
                                                                    className="mt-1 text-sm line-clamp-2"
                                                                    style={{ color: productDescriptionColor }}
                                                                >
                                                                    {producto.descripcion}
                                                                </p>
                                                            )}
                                                        </div>
                                                        <div className="flex-none">
                                                            <span
                                                                className="text-base font-bold"
                                                                style={{ color: productPriceColor }}
                                                            >
                                                                {producto.precio.toLocaleString('es-ES', {
                                                                    style: 'currency',
                                                                    currency: 'EUR'
                                                                })}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                            {productosCategoria.length > (config.productsPerCategoryPreview || 3) && (
                                                <div
                                                    className="p-4 text-center cursor-pointer transition-colors"
                                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = productCardHoverColor}
                                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = productCardBgColor}
                                                    onClick={() => !isPreview && setSelectedCategoria(categoria._id)}
                                                >
                                                    <span
                                                        className="font-medium"
                                                        style={{ color: productPriceColor }}
                                                    >
                                                        Ver {productosCategoria.length - (config.productsPerCategoryPreview || 3)} productos más
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                )}

                {/* Modal de previsualización de imagen */}
                {selectedImage && !isPreview && (
                    <ImagePreviewModal
                        imageUrl={selectedImage}
                        productName={selectedProductName}
                        onClose={() => {
                            setSelectedImage(null);
                            setSelectedProductName('');
                        }}
                    />
                )}

                {Object.keys(productosPorCategoria).length === 0 && (
                    <div className="text-center py-12">
                        <p className="text-lg" style={{ color: productDescriptionColor }}>
                            {texts.noProductsMessage || 'No se encontraron productos que coincidan con tu búsqueda.'}
                        </p>
                    </div>
                )}
            </div>

            {/* Floating Register Button */}
            {config.showFloatingButton && (
                <Link
                    to={`/qr-register/${marca?.tiendas?.[0]}`}
                    className="fixed bottom-4 right-4 z-50 px-4 py-2 rounded-full shadow-lg transition-colors flex items-center space-x-2"
                    style={{
                        backgroundColor: floatingButtonBgColor,
                        color: floatingButtonTextColor
                    }}
                    onMouseEnter={(e) => e.target.style.opacity = '0.9'}
                    onMouseLeave={(e) => e.target.style.opacity = '1'}
                >
                    <FaGift className="w-5 h-5" />
                    <span>{texts.floatingButtonText || 'Únete al Club'}</span>
                </Link>
            )}

            {/* Welcome Modal */}
            {!isPreview && (
                <WelcomeModal
                    isOpen={showWelcomeModal}
                    onClose={() => setShowWelcomeModal(false)}
                    marca={marca}
                    texts={texts}
                    styles={styles}
                />
            )}
        </div>
    );
};

export default ProductosPublicPageContent;

